var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DForm',_vm._g({attrs:{"value":_vm.value}},{ ..._vm.$listeners, input: _vm.input }),[_c('DField',_vm._b({staticClass:"mb-6",attrs:{"value":_vm.dateText}},'DField',_vm.date,false)),_c('DField',_vm._b({key:"tag",staticClass:"mb-6"},'DField',_vm.tag,false)),_c('DField',_vm._b({key:"logMessage",staticClass:"mb-6"},'DField',_vm.logMessage,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }